var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#323232",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,19v0c0,-2.209 1.791,-4 4,-4h4c2.209,0 4,1.791 4,4v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4749,6.02513c1.36684,1.36684 1.36684,3.58291 0,4.94975c-1.36684,1.36684 -3.58291,1.36684 -4.94975,1.77636e-15c-1.36684,-1.36684 -1.36684,-3.58291 -8.88178e-16,-4.94975c1.36684,-1.36684 3.58291,-1.36684 4.94975,-8.88178e-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,14h3c1.657,0 3,1.343 3,3v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2678,6.73223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUser);
export default __webpack_public_path__ + "static/media/Group-User.1b0c965894f17d49f0438754f15c81b2.svg";
export { ForwardRef as ReactComponent };